module.exports = __webpack_public_path__ + "img/V86.175c0316.jpg";